import { ComponentPropsWithRef } from 'react';

import { UPDATE_ALBUM_NAME, useAlbumContext } from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import Input from '@/components/base/Input';
import Label from '@/components/base/Label';

type InputAlbumNameProps = ComponentPropsWithRef<'div'> & {
    error?: string | null;
    onChange?: () => void;
};

export const InputAlbumName = ({ error, onChange, ...props }: InputAlbumNameProps) => {
    const { t } = useTranslation();
    const { albumInfo, dispatch } = useAlbumContext();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: UPDATE_ALBUM_NAME,
            payload: e.target.value
        });

        onChange?.();
    };

    return (
        <div {...props}>
            <Label htmlFor="album-name" required>
                {t('content:modal.name')}
            </Label>
            <Input
                id="album-name"
                name="album-name"
                autoComplete="off"
                value={albumInfo?.name}
                error={error || undefined}
                onChange={handleChange}
                maxLength={50}
                charsCount={albumInfo?.name?.length ?? 0}
            />
        </div>
    );
};
